import axios from 'axios';

const teanaDM = axios.create({});

const teanaApi = axios.create({});
const elsApi = axios.create({});

const statusData = { type: 'success', status: '200', msg: '' };

// 자동완성
export const requestAutoCompleteList = async text => {
  let data = { status: statusData, data: {} };

  try {
    const res = await teanaApi.post('/AutoCom', { domain: process.env.REACT_APP_DOMAIN_ID, area: text });

    data = { ...data, data: res.data.autoSentence };
  } catch (err) {
    data = { ...data, status: { ...statusData, status: '400', msg: e.message } };
  }
  return data;
};

// DM
export const requestDMPost = async req => {
  let getData = { status: statusData, data: {} };
  try {
    const resp = await teanaDM.post(req.url, req.param);
    getData = { ...getData, data: resp.data };
  } catch (e) {
    const statusSet = { ...statusData, status: '400', msg: e.message };
    getData = { ...getData, status: statusSet };
  }
  return getData;
};

/* LOGO */
export const requestLogo = async () => {
  let data = { status: statusData, data: {} };
  try {
    const res = await elsApi.post('/Logo');
    data = { ...data, data: res.data };
  } catch (err) {
    data = { ...data, status: { ...statusData, status: '400', msg: e.message } };
  }
  return data;
};

// 조직도
export const requestOrganizList = async dept => {
  let data = { status: statusData, data: {} };
  try {
    const res = await teanaApi.post('/Organiz', { workDept: dept });
    /*     console.log(`consoleMessage::: workDept::::` + JSON.stringify(res)); */
    data = { ...data, data: res.data.dept };
  } catch (err) {
    data = { ...data, status: { ...statusData, status: '400', msg: e.message } };
  }
  return data;
};
// 조직도(two dept)
export const requestTwoDeptList = async index => {
  let data = { status: statusData, data: {} };
  try {
    const res = await teanaApi.post('/twoDept', { twoDept: index });
    console.log(`consoleMessage::: twoDept::::` + JSON.stringify(res));
    data = { ...data, data: res.data.index };
  } catch (err) {
    data = { ...data, status: { ...statusData, status: '400', msg: e.message } };
  }
  return data;
};
// not match 검색 API
export const requestSearch = async text => {
  let data = { status: statusData, data: {} };
  try {
    const res = await teanaApi.post('/searchAPI', { str: text });
    console.log(`consoleMessage::: searchAPI::::` + JSON.stringify(res));
    data = { ...data, data: res.data };
  } catch (err) {
    data = { ...data, status: { ...statusData, status: '400', msg: e.message } };
  }
  return data;
};
